import React from 'react';
import { Link } from 'react-router-dom';
import { HomeSectionHeaderProps } from '../interfaces';
import './HomeSectionHeader.scss';

const HomeSectionHeader: React.FC<HomeSectionHeaderProps> = ({
  eyebrow,
  title,
  titleId,
  linkLabel,
  linkTo,
}) => (
  <div className="home-section__header">
    <div>
      <p className="home-eyebrow">{eyebrow}</p>
      <h2 id={titleId}>{title}</h2>
    </div>
    {linkLabel && linkTo && (
      <Link to={linkTo} className="home-section__link">
        {linkLabel}
      </Link>
    )}
  </div>
);

export default HomeSectionHeader;
